<template lang="pug">
  .card.test-card
    .card-content
      .media
        .media-content
          p.title.is-4
            b-icon(icon="clipboard-check-outline")
            |  {{ test.name }}
          p.subtitle.is-6(v-if="test.category") {{ test.category.name }}
      .content(v-if="test.description") {{ test.description }}

    .card-footer
      b-tooltip.card-footer-item.is-pulled-left(v-if="test.time_limit" position="is-bottom" label="Ограничение по времени")
        b-icon(icon="timer")
        span {{ test.time_limit }} минут

      b-tooltip.card-footer-item.is-pulled-left(position="is-bottom" label="Количество попыток")
        span {{ test.user_sessions.length }} из
        span.ml-5
          template(v-if="test.attempts_count") {{ test.attempts_count }}
          b-icon(v-else icon="infinity")

      a.card-footer-item(v-if="test.canStartTest()" @click="startTest")
        span Начать тест
        b-icon(icon="arrow-right-circle")
      .card-footer-item(v-else)
        b-icon(icon="check-circle" type="is-success")
        span Тест завершен
</template>

<script>
import { mapGetters } from 'vuex';
import Test from '@/models/Test';
import TestSession from '@/models/TestSession';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'test-card',

  props: {
    test: {
      type: Test,
    },
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    startTest() {
      if (!this.test.canStartTest()) {
        Toast.open({ message: 'Вы уже проходили этот тест', type: 'is-warning' });
        return;
      }

      const session = new TestSession({
        user_id: this.user.id,
        test_id: this.test.id,
      });

      session
        .$save()
        .then(() => {
          window.location.reload();
        })
        .catch(({ message }) => {
          Toast.open({ message, type: 'is-danger' });
        });
    },
  },
};
</script>
